import { opacity, spacing } from '@lamimed/pantheon';
import { transparentize } from 'polished';
import styled, { css } from 'styled-components';

interface SpinnerContainerProps {
  hasBackground?: boolean;
  marginBottom?: keyof typeof spacing;
  marginTop?: keyof typeof spacing;
  hasCustomColor?: boolean;
}

export const customSpinnerModifier = (color: string) => css`
  svg {
    path:first-child {
      stroke: ${transparentize(opacity.medium, color)};
    }

    & > defs {
      > linearGradient {
        > stop {
          stop-color: ${color};
        }
      }
    }
  }
`;

export const SpinnerContainer = styled.div<SpinnerContainerProps>`
  ${({
    hasBackground = true,
    marginBottom = 'none',
    marginTop = 'none',
    theme,
    hasCustomColor = false,
  }) => css`
    margin-bottom: ${spacing[marginBottom]};
    margin-top: ${spacing[marginTop]};

    > div {
      ${!hasBackground && 'background: transparent'};

      ${!hasCustomColor && customSpinnerModifier(theme.primaryColor)}
    }
  `};
`;
